import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

const productFragment = `
 product {
      _id
      code
      name
      coverImage
      coverImageThumb
      inStock
      requiredComputedQuantityOnHand
      inventory {
        _id
        quantityOnHand
      }
      productType
    }
`

const addressFragment = `
    _id
    street1
    street2
    city
    state
    zip
    country
    fullAddress
`

export const orderFragment = `_id
  code
  status
  updatedAt
  createdAt
  net
  gross
  minimumOrderAmount
  shippingFee
  isManualShippingRate
  remarks
  by {
    _id
    profile {
      _id
      name
      picture
      email
    }
    status
    address {
       _id
       fullAddress
       street1
    }
  }
  items {
    _id
    ${productFragment}
    quantity
    price
    net
    remarks
    uom {
      _id
      code
      name
      symbol
    }
  }
  discount
  taxAmount
  customerPoNumber
  allItemsInStock
  shippingAddress {
    ${addressFragment}
  }

  shipping {
    _id
    billToAccount
    billToCountryCode
    billToPostalCode
    billToCustomer
    shipmentId
  }
  allowPrePayment
  allItemsInStockByOnHandAndComputedQuantity
  isCart
`

export const queries = buildGraphqlQuery('Order', orderFragment)

export const shippingFeeUpdateQuery = buildGraphqlQuery(
  'Order',
  `_id
  updatedAt
  net
  gross
  shippingFee`
)

export const shippingAddressQuery = buildGraphqlQuery(
  'Order',
  `_id shippingAddress {
    ${addressFragment}
  }  `
)

export const customerAddressQuery = buildGraphqlQuery(
  'Customer',
  `_id address {
    ${addressFragment}
  }  `
)

export const orderGetCartQuery = gql`
  query orderGetCart($filter: JSON!) {
    orderGetCart(filter: $filter) {
        _id
      ${orderFragment}
    }
  }
`
